function setHeaderGroupHeight() {
  var headerGroup = document.querySelector('.header-group');
  if (!headerGroup) return;
  var isMobile = window.innerWidth <= 1090;
  if (isMobile) {
    var mobileHeader = document.querySelector('#header');
    if (!mobileHeader) return;
    var mobileHeight = mobileHeader.getBoundingClientRect().height;
    headerGroup.style.height = mobileHeight + 'px';
  } else {
    var navWrapper = document.querySelector('.header .main-nav__wrapper');
    if (!navWrapper) return;
    var desktopHeight = navWrapper.getBoundingClientRect().height;
    headerGroup.style.height = desktopHeight + 'px';
  }
}
$(document).ready(function () {
  //setHeaderGroupHeight();
  var navWrapper = document.querySelector('.header .main-nav__wrapper');
  var mobileHeader = document.querySelector('#header');

  var resizeObserver = new ResizeObserver(function () {
    //setHeaderGroupHeight();
  });
  if (navWrapper) {
    resizeObserver.observe(navWrapper);
  }
  if (mobileHeader) {
    resizeObserver.observe(mobileHeader);
  }
});
$(window).on('resize', function () {
  requestAnimationFrame(function () {
    //setHeaderGroupHeight();
  });
});


$(document).ready(function() {

  // Function to find the index of the selected image URL in the dropdown
    function findVariantIndexByImageURL(imageURL) {
        return $('.find_form_this option[data-image="' + imageURL + '"]').data('index');
    }

    // Event listener for the click on the product thumbnails
    $('.product-gallery__thumbnail').on('click', function() {
        // Get the clicked image URL
        const clickedImageURL = $(this).find('img').attr('src');

        // Find the index of the selected image in the dropdown
        const selectedIndex = findVariantIndexByImageURL(clickedImageURL);

        // Set the dropdown to the found index
        $('.single-option-selector').prop('selectedIndex', selectedIndex).trigger('change');
    });  

    
      if ($(window).width() <= 798) {
      $('.closer_search').show();
      //$('header[data-desktop-header]').empty();
  
      $(document).on('click', '.custom_Search_opener_mobile', function(event) {
        event.preventDefault();
        $('.mobile_custom_search').fadeIn();
      });
      $(document).on('click', '.closer_search', function(event) {
        event.preventDefault();
        console.log('click')
        $('.mobile_custom_search').fadeOut();
      });
    }
  $( ".btn-search" ).on( "click", function() {
    $( ".search-bar-container" ).slideToggle( "100" );
  });

    if ($(window).width() <= 767) {
      // Move element 'text-content' before 'logo-img'
      $(".text-content").insertBefore(".logo-img");
    }

    $(document).on("click", ".js-read-more", function () {
      var wrap = $(this).closest(".one-whole");

      wrap.find(".js-desc-short").hide();
      wrap.find(".js-desc-full").show();
    });

    $(document).on("click", ".js-read-less", function () {
      var wrap = $(this).closest(".one-whole");

      wrap.find(".js-desc-full").hide();
      wrap.find(".js-desc-short").show();
    });


  $(document).on('click', '.custom_Search_opener_mobile', function (e) {
    e.preventDefault();

    $('.mobile_custom_search').addClass('enable-mobile-search');
  });

  $(document).on('click', '.psm__input_row .psm__clear', function () {
    $('.mobile_custom_search').removeClass('enable-mobile-search');
  });

  
  $(document).on('click', '.search_cart', function(e){
    var items = [];
    e.preventDefault();
    var ID = $(this).attr('PRODUCT-ID');
    var qty = $(this).attr('add_to');
    //console.log(ID);

    items.push({
      id: ID,
      quantity: qty,
    } )

    var data = {
      items: items
    };

    $clickedElement = $(this);
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function() {
        //console.log('added....');
        $clickedElement.find('.need_to_Add').addClass('hide____');
        $clickedElement.find('.added_').removeClass('hide____');
          // Get the current cart count and parse it as an integer
        var current_count = parseInt($('.icon-cart .cart_count').html());
        
        // Increment the count by 1
        var new_count = parseInt(current_count, 10) + parseInt(qty, 10);
        
        // Update the cart count on the website
        $('.cart_count').text(new_count);
        // setTimeout(function() {
        //   $clickedElement.find('.need_to_Add').removeClass('hide____');
        // $clickedElement.find('.added_').addClass('hide____');
        // }, 3000);
      },
      error: function(xhr, status, error) {
        alert('Already In Cart');
      }
    });
  });   


    $('div.main_sport_block').click(function(){
      var current_sports_data =  $(this).find('.main-sport_inner_links').html();
      $('.sports_popup_content').html(current_sports_data);
      $('.fixed_bg_wrapper').show();
      $('.sports_main_popup_wrapper').fadeIn();
    })
    $('.sports_popup_closer').click(function(){
      closer_sports()
    })
    $('.popup_main_bg').click(function(){
      closer_sports()
    })
    function closer_sports(){
      $('.sports_popup_content').empty();
      $('.fixed_bg_wrapper').hide();
      $('.sports_main_popup_wrapper').fadeOut();
    }



    // page search here code 
    function debounce_(func, wait) {
      let timeout;
      return function() {
        const context = this,
          args = arguments;
        const later = function() {
          timeout = null;
          func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

  function getSigningsSearchQuery() {
    return ($('#search-input_page').val() || '').toLowerCase().trim();
  }

  function applySigningsSearch() {
    var value_ = getSigningsSearchQuery();

    $('[search-item]').each(function() {
      var haystack = ($(this).attr('search-item') || '').toLowerCase();
      var match = !value_ || haystack.indexOf(value_) !== -1;
      $(this).toggle(match);
    });
  }

  $('#search-input_page').on('input', debounce_(applySigningsSearch, 300));


    $(document).ready(function () {
  var $filterContainers = $('.filter_container');

  /**
   * Each signing card lives inside `.filter_container` next to the section title.
   * Never call .empty() on those containers — it removes headings and leaves a tall blank strip.
   * Preserve which container each card belonged to so "Best selling" restores the original collection layout.
   */
  var itemMeta = [];
  $filterContainers.find('div[search-item]').each(function () {
    itemMeta.push({ el: this, container: this.closest('.filter_container') });
  });
  var originalItems = itemMeta.map(function (m) {
    return m.el;
  });

  function detachAllCards() {
    $filterContainers.find('div[search-item]').detach();
  }

  function restoreOriginalLayout() {
    detachAllCards();
    itemMeta.forEach(function (m) {
      $(m.container).append(m.el);
    });
  }

  function renderSortedIntoFirstColumn(sortedItems) {
    detachAllCards();
    var $firstContainer = $filterContainers.first();
    $.each(sortedItems, function (i, item) {
      $firstContainer.append(item);
    });
  }

  function parseSortDate(el) {
    var raw = $(el).attr('search-date');
    if (!raw) return null;
    var ts = new Date(raw).getTime();
    return isNaN(ts) ? null : ts;
  }

  function applySigningsSort() {
    var sortBy = $('#signings-sort').val();

    if (sortBy === 'best-selling') {
      restoreOriginalLayout();
      applySigningsSearch();
      return;
    }

    var sortedItems = originalItems.slice();

    sortedItems.sort(function (a, b) {
      if (sortBy === 'name-az' || sortBy === 'name-za') {
        var nameA = ($(a).attr('search-item') || '').toUpperCase();
        var nameB = ($(b).attr('search-item') || '').toUpperCase();
        return sortBy === 'name-az' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      }

      if (sortBy === 'date-earliest' || sortBy === 'date-latest') {
        var dateA = parseSortDate(a);
        var dateB = parseSortDate(b);
        var latestFirst = sortBy === 'date-latest';

        if (dateA === null && dateB === null) return 0;
        if (dateA === null) return 1;
        if (dateB === null) return -1;

        return latestFirst ? dateB - dateA : dateA - dateB;
      }

      return 0;
    });

    renderSortedIntoFirstColumn(sortedItems);
    applySigningsSearch();
  }

  $('#signings-sort').on('change', applySigningsSort);
});

});

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionFilterScrollbar();
    initProductVariantScrollbar();
  });
  function initCollectionFilterScrollbar() {
    const lists = document.querySelectorAll('[data-simplebar]');
    if (!lists.length) return;
    
    lists.forEach(function (el) {
      const itemCount = el.querySelectorAll('.facets-list').length;
      let instance = SimpleBar.instances.get(el);
      
      if (itemCount > 3) {
        if (instance) {
          instance.recalculate();
        } else {
          instance = new SimpleBar(el, { autoHide: false, clickOnTrack: false });
        }
      } else if (instance) {
        instance.unMount();
        SimpleBar.instances.delete(el);
      }
    });
  }

function initProductVariantScrollbar() {
  const lists = document.querySelectorAll('.product-variant-option-list');
  if (!lists.length) return;
  
  lists.forEach(function (el) {
    const itemCount = el.querySelectorAll('.option-row').length;
    let instance = SimpleBar.instances.get(el);
    
    if (itemCount > 3) {
      if (instance) {
        instance.recalculate();
      } else {
        instance = new SimpleBar(el, { autoHide: false, clickOnTrack: false });
      }
    } else if (instance) {
      instance.unMount();
      SimpleBar.instances.delete(el);
    }
  });
}
